<template>
  <li
    :class="['nav-item', { open: checkOpenMenu, collapsing: isCollapsing }]"
    v-permission="permission"
  >
    <router-link :to="path" class="nav-link">
      <i v-if="iconClass" :class="`nav-icon ${iconClass}`"></i>
      <p>
        {{ title }}
        <i v-if="hasChildren" class="fas fa-angle-right right"></i>
      </p>
    </router-link>

    <ul v-if="hasChildren" class="nav nav-treeview pl-3">
      <MenuItem
        v-for="(item, index) in children"
        :title="item.title"
        :icon-class="item.iconClass"
        :children="item.children"
        :path="item.path"
        :is-open="isOpen"
        :is-collapsing="isCollapsing"
        :permission="item.permission"
        :key="item.path || index.toString()"
        @handleClickMenu="toggleMenus"
      />
    </ul>
  </li>
</template>

<script>
import MenuItem from "./MenuItem.vue";

export default {
  name: "MenuItem",
  components: {
    MenuItem,
  },
  props: {
    isOpen: { type: String, default: "" },
    isCollapsing: { type: Boolean, default: false },
    path: { type: String, default: "/" },
    permission: { type: String, default: "" },
    title: { type: String, required: true },
    iconClass: { type: String, default: "" },
    children: { type: Array, default: () => [] },
  },
  computed: {
    checkOpenMenu() {
      return this.title == this.isOpen;
    },

    hasChildren() {
      return this.children && this.children.length > 0;
    },
  },
  methods: {
    toggleMenus() {
      this.$emit("handleClickMenu", this.title);
    },
  },
  mounted() {},
};
</script>

<style scoped>
@keyframes expandHeight {
  0% {
    max-height: 0;
    height: 0;
  }
  100% {
    max-height: 500px; /* Adjust according to your content */
    height: 100%;
  }
}

@keyframes collapseHeight {
  0% {
    max-height: 500px; /* Adjust according to your content */
    height: 100%;
  }
  100% {
    max-height: 0;
    height: 0;
  }
}

.nav--treeview {
  overflow: hidden;
  height: 0;
  max-height: 0;
  transition: max-height 0.3s ease-in-out, height 0.3s ease-in-out;
}

.nav-item.open > .nav--treeview {
  animation: expandHeight 0.3s ease-in-out forwards;
}

.nav-item.collapsing > .nav--treeview {
  animation: collapseHeight 0.3s ease-in-out forwards;
}
</style>
